import { createSelector } from '@reduxjs/toolkit';
import { IApplicationState } from 'shared/types/redux';

export const selectMarkedListItems = createSelector(
  (state: IApplicationState) => state.landing.seoMarkedList?.markedList?.items,
  items => items || [],
);
